<template>
  <div>

  </div>
</template>

<script>
export default {
  name: "Name",
  components: {},
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  },
  computed: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {},
  watch: {},
  filters: {}
};
</script>

<style scoped>
</style>
